import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconInboxChecked: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"inbox-checked, saved"} maskId="square-filled-radius-0-stroke-1-IconInboxChecked"><path fillRule="evenodd" clipRule="evenodd" d="M18.6947 3.86802L10.9189 15.287L6.29295 10.5405L7.00909 9.84254L10.7811 13.7128L17.8681 3.30518L18.6947 3.86802ZM4 13.9999V19.9999H20V13.9999H21V20.9999H3V13.9999H4Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconInboxChecked;
